import { render, staticRenderFns } from "./form-ai-code-articles.vue?vue&type=template&id=37925912&scoped=true"
import script from "./form-ai-code-articles.vue?vue&type=script&lang=js"
export * from "./form-ai-code-articles.vue?vue&type=script&lang=js"
import style0 from "./form-ai-code-articles.vue?vue&type=style&index=0&id=37925912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37925912",
  null
  
)

export default component.exports